<template>
  <el-form-item :label="i18nt('designer.setting.format')">
    <el-select v-model="optionModel.format" filterable allow-create>
      <el-option label="YYYY-MM-DD HH:mm" value="YYYY-MM-DD HH:mm"></el-option>
      <el-option label="YYYY-MM-DD HH:mm:ss" value="YYYY-MM-DD HH:mm:ss"></el-option>
      <el-option label="YYYY/MM/DD HH:mm" value="YYYY/MM/DD HH:mm"></el-option>
      <el-option label="YYYY/MM/DD HH:mm:ss" value="YYYY/MM/DD HH:mm:ss"></el-option>
      <el-option label="YYYY/M/D H:m" value="YYYY/M/D H:m"></el-option>
      <el-option label="YYYY/M/D H:m:s" value="YYYY/M/D H:m:s"></el-option>
      <el-option label="YYYY年MM月DD日 HH时mm分" value="YYYY年MM月DD日 HH时mm分"></el-option>
      <el-option label="YYYY年MM月DD日 HH时mm分ss秒" value="YYYY年MM月DD日 HH时mm分ss秒"></el-option>
      <el-option label="YYYY年M月D日 H时m分" value="YYYY年M月D日 H时m分"></el-option>
      <el-option label="YYYY年M月D日 H时m分ss秒" value="YYYY年M月D日 H时m分ss秒"></el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import { watch, toRefs } from 'vue';
import { useI18n } from '@/utils/i18n';
import { useProperty } from '../propertyMixin';
import dayjs from 'dayjs';

export default {
  name: 'm-datetime-format-editor',
  props: {
    designer: Object,
    optionModel: Object,
    selectedWidget: Object,
  },
  setup(props) {
    const { i18nt } = useI18n();
    const propertyMixin = useProperty();

    watch(
      () => props.optionModel.format,
      (newFormat, oldFormat) => {
        if (!props.optionModel.defaultValue) return;

        let oldDateObj = dayjs(props.optionModel.defaultValue, oldFormat);
        props.optionModel.defaultValue = oldDateObj.format(newFormat);
        propertyMixin.emitDefaultValueChange();
      }
    );

    return {
      i18nt,
      ...toRefs(props),
    };
  },
};
</script>

<style scoped></style>
